export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10725.74c007b1.jpg";